module.exports = __webpack_public_path__ + "static/media/MEDCHASIU_MENU-normal.5d15973f.png";